import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import {
	clearTenantDetail,
	loadTenant,
	updateTenantDetail,
	loadEmployees,
	requestOtp,
	clearOtp,
} from './../../store/actions';
import { getTenantDetailForEdit } from '../../store/selectors/tenantDetail';
import TenantDetail from './TenantDetail';

const mapStateToProps = (state) => ({
	tenantDetail: getTenantDetailForEdit(state),
	employees: state.employees,
	otp: state.otp,
});

const actions = {
	clearTenantDetail,
	loadTenant,
	updateTenantDetail,
	loadEmployees,
	requestOtp,
	clearOtp,
};

export default withRouter(connect(mapStateToProps, actions)(TenantDetail));
